import React, { Suspense, useMemo } from 'react';
import { tastics } from 'frontastic/tastics';
import { TasticWrapperProps } from './types';
import { deviceVisibility } from '../../utils/device-visibility';
import { highlight } from '../../utils/highlight';
import { injectDataSources } from '../../utils/inject-datasources';
import MissingTastic from '../missing-tastic';

const TasticWrapper = ({ data, params, searchParams, dataSources, isHighlighted, categories }: TasticWrapperProps) => {
  const TasticComponent = tastics[data.tasticType] as React.ComponentType<{
    data: typeof data.configuration;
    params: typeof params;
    searchParams: typeof searchParams;
    categories: typeof categories;
  }>;

  const resolvedTasticData = useMemo(() => {
    return dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration;
  }, [dataSources, data.configuration]);

  const wrapperClasses = `${highlight(isHighlighted)} ${deviceVisibility(data.configuration)}`;

  if (!TasticComponent) {
    return (
      <div id={data?.tasticId} className={wrapperClasses}>
        <MissingTastic data={data} />
      </div>
    );
  }

  return (
    <div id={data?.tasticId} className={wrapperClasses}>
      <Suspense fallback={<div>Loading...</div>}>
        <TasticComponent
          data={resolvedTasticData}
          params={params}
          searchParams={searchParams}
          categories={categories}
        />
      </Suspense>
    </div>
  );
};

export default TasticWrapper;
